import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { environment } from '../../../../environments/environment'
import { JSONRpc } from '../../../services/service-jsonrpc'
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud'
import { Permission } from '../_models/permission.model'
import { Role } from '../_models/role.model'
import { User } from '../_models/user.model'
import { MatSnackBar } from '@angular/material';

const API_USERS_URL = 'api/users'
const API_PERMISSION_URL = 'api/permissions'
const API_ROLES_URL = 'api/roles'

@Injectable()
export class AuthService {
	constructor(private http: HttpClient,
				private snackBar: MatSnackBar
		
	) { }
	// Authentication/Authorization
	login(email: string, password: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: "2.0",
			method: "webservice.connection:connect",
			params: {
				login: email,
				password: password
			}
		})
		return this.http.post<any>(environment.webservice, rpcMethod).pipe(
			map((data) => {
				let _user = new User()
				if (data.result && data.result.connect == "OK") {
					this.setUser(_user, data);
					return _user
				}
				else
					return false

			})
		)
	}
    
    isConnected(): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: "2.0",
			method: "webservice.connection:isconnected",
			params: {

			}
		})
    	return this.http.post<any>(environment.webservice, rpcMethod);
    };
	
	kindOpenId(): Observable<any> {
		let rpcMethod = new JSONRpc({
	        jsonrpc : "2.0",
	        method:"webservice.connection:kindOpenid",
	        params: {
	          
	        }
	      });
	    return this.http.post<any>(environment.webservice, rpcMethod).pipe(
	        map((data) => {
			  let cn:string=null;
	          if(data.result ){
				  cn=data.result
			  }
			  return cn;
					
	        })
	    );

	}

	 loginOpenId(): Observable<any> {
		let rpcMethod = new JSONRpc({
	        jsonrpc : "2.0",
	        method:"webservice.connection:connectOpenid",
	        params: {
	          
	        }
	      });
	    return this.http.post<any>(environment.webservice, rpcMethod).pipe(
	        map((data) => {
	            let _user = new User();
	            if(data.result && data.result.connect == "OK"){
					_user.id = data.result.user.ID
					_user.username = data.result.user.login
					_user.email = data.result.user.email
					_user.accessToken = data.result.token
					_user.pic = data.result.user.avatar.data
					_user.fullname = data.result.user.firstname + " " + data.result.user.name
					_user.nom = data.result.user.name
					_user.prenom = data.result.user.firstname
					_user.sexe = data.result.user.sexe
					_user.lists = data.result.lists
					_user.droits = data.result.droits ? data.result.droits : ''
					_user.droitsObjets = data.result.droitsObjets ? data.result.droitsObjets : ''
					_user.signature = data.result.signature ? data.result.signature : ''
					_user.signature_text = data.result.signature_text ? data.result.signature_text : ''
					_user.signature_url = data.result.signature_url ? data.result.signature_url : ''
					_user.signature_etat = data.result.signature_etat ? data.result.signature_etat : ''
					_user.vidalAPI = data.result.vidalAPI
					_user.type = data.result.user.type
					environment.openIDToken = data.result.openid_token ? data.result.openid_token:'' ;
					environment.tokenauth = data.result.token
					environment.production = data.result.environnement === "prod" ? true : false
	                return _user;
	            }
	            else {
					if(data.result && data.result.connect == "KO"){
						/*
						if(data.result.userFound!=undefined && ! data.result.userFound){
							let messageCnx:string='Connexion fonctionnelle impossible:';
							messageCnx+='\nVotre utlisateur est inconnu d\'Atyl';
							messageCnx+='\nVeuillez contacter votre administrateur';
								this.snackBar.open(messageCnx,'', {
							           duration: 5000,
									   panelClass: ['success-snackbar']
							 });		
						}*/
					   return data.result;
					}
					if(data.result && data.result.connect == "KO"){
						
					}
					if (data.error!=undefined) {
						let messageCnx:string='Erreur connexion';
						if (data.error.data!=undefined)
							messageCnx+=':\n'+data.error.data;
						messageCnx+='\nVeuillez contacter votre administrateur';
						this.snackBar.open(messageCnx,'', {
						           duration: 5000,
								   panelClass: ['success-snackbar']
						 });
						 
					}
	            }
	        })
	    );

	}
	
	
	loginLDAP(): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: "2.0",
			method: "webservice.connection:connectldap",
			params: {

			}
		})
		return this.http.post<any>(environment.webservice, rpcMethod).pipe(
			map((data) => {
				let _user = new User()
				if (data.result && data.result.connect == "OK") {
					_user.id = data.result.user.ID
					_user.username = data.result.user.login
					_user.email = data.result.user.email
					_user.accessToken = data.result.token
					_user.pic = data.result.user.avatar.data
					_user.fullname = data.result.user.firstname + " " + data.result.user.name
                    _user.nom = data.result.user.name
                    _user.prenom = data.result.user.firstname
                    _user.sexe = data.result.user.sexe
					_user.lists = data.result.lists
					_user.droits = data.result.droits ? data.result.droits : ''
                    _user.droitsObjets = data.result.droitsObjets ? data.result.droitsObjets : ''
					_user.signature = data.result.signature ? data.result.signature : ''
					_user.signature_text = data.result.signature_text ? data.result.signature_text : ''
					_user.signature_url = data.result.signature_url ? data.result.signature_url : ''
					_user.signature_etat = data.result.signature_etat ? data.result.signature_etat : ''
					_user.vidalAPI = data.result.vidalAPI
					_user.type = data.result.user.type
					environment.openIDToken = data.result.openid_token ? data.result.openid_token:'' ;
					environment.tokenauth = data.result.token
					environment.production = data.result.environnement === "prod" ? true : false
					
					return _user
				}
				else
					return false

			})
		)

	}

	getUserByToken(): Observable<User> {
		let rpcMethod = new JSONRpc({
			jsonrpc: "2.0",
			method: "webservice.connection:user"
		})
		return this.http.post<any>(environment.webservice, rpcMethod).pipe(
			map((data) => {
				if (data.result) {
                    console.log("DATA",data)
					let _user = new User()
					_user.id = data.result.ID
					_user.username = data.result.login
					_user.email = data.result.email
					_user.accessToken = environment.tokenauth
					_user.pic = data.result.avatar.data
					_user.fullname = data.result.firstname + " " + data.result.name
                    _user.nom = data.result.name
                    _user.prenom = data.result.firstname
                    _user.sexe = data.result.sex
					_user.lists = data.result.lists
					_user.droits = data.result.droits ? data.result.droits : ''
                    _user.droitsObjets = data.result.droitsObjets ? data.result.droitsObjets : ''
					_user.vidalAPI = data.result.vidalAPI
					_user.signature = data.result.signature ? data.result.signature : ''
					_user.signature_text = data.result.signature_text ? data.result.signature_text : ''
					_user.signature_url = data.result.signature_url ? data.result.signature_url : ''
					_user.signature_etat = data.result.signature_etat ? data.result.signature_etat : ''
					_user.type = data.result.type ? data.result.type : 'PMI'
					return _user
				}
				else
					return null
			})
		)
	}

	register(user: User): Observable<any> {
		const httpHeaders = new HttpHeaders()
		httpHeaders.set('Content-Type', 'application/json')
		return this.http.post<User>(API_USERS_URL, user, { headers: httpHeaders })
			.pipe(
				map((res: User) => {
					return res
				}),
				catchError(err => {
					return null
				})
			)
	}

	/*
	 * Submit forgot password request
	 *
	 * @param {string} email
	 * @returns {Observable<any>}
	 */
	public requestPassword(email: string): Observable<any> {
		return this.http.get(API_USERS_URL + '/forgot?=' + email)
			.pipe(catchError(this.handleError('forgot-password', []))
			)
	}


	getAllUsers(): Observable<User[]> {
		return this.http.get<User[]>(API_USERS_URL)
	}

	getUserById(userId: number): Observable<User> {
		return this.http.get<User>(API_USERS_URL + `/${userId}`)
	}


	// DELETE => delete the user from the server
	deleteUser(userId: number) {
		const url = `${API_USERS_URL}/${userId}`
		return this.http.delete(url)
	}

	// UPDATE => PUT: update the user on the server
	updateUser(_user: User): Observable<any> {
		const httpHeaders = new HttpHeaders()
		httpHeaders.set('Content-Type', 'application/json')
		return this.http.put(API_USERS_URL, _user, { headers: httpHeaders })
	}

	// CREATE =>  POST: add a new user to the server
	createUser(user: User): Observable<User> {
		const httpHeaders = new HttpHeaders()
		httpHeaders.set('Content-Type', 'application/json')
		return this.http.post<User>(API_USERS_URL, user, { headers: httpHeaders })
	}

	// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
	// items => filtered/sorted result
	findUsers(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		const httpHeaders = new HttpHeaders()
		httpHeaders.set('Content-Type', 'application/json')
		return this.http.post<QueryResultsModel>(API_USERS_URL + '/findUsers', queryParams, { headers: httpHeaders })
	}

	// Permission
	getAllPermissions(): Observable<Permission[]> {
		return this.http.get<Permission[]>(API_PERMISSION_URL)
	}

	getRolePermissions(roleId: number): Observable<Permission[]> {
		return this.http.get<Permission[]>(API_PERMISSION_URL + '/getRolePermission?=' + roleId)
	}

	// Roles
	getAllRoles(): Observable<Role[]> {
		return this.http.get<Role[]>(API_ROLES_URL)
	}

	getRoleById(roleId: number): Observable<Role> {
		return this.http.get<Role>(API_ROLES_URL + `/${roleId}`)
	}

	// CREATE =>  POST: add a new role to the server
	createRole(role: Role): Observable<Role> {
		// Note: Add headers if needed (tokens/bearer)
		const httpHeaders = new HttpHeaders()
		httpHeaders.set('Content-Type', 'application/json')
		return this.http.post<Role>(API_ROLES_URL, role, { headers: httpHeaders })
	}

	// UPDATE => PUT: update the role on the server
	updateRole(role: Role): Observable<any> {
		const httpHeaders = new HttpHeaders()
		httpHeaders.set('Content-Type', 'application/json')
		return this.http.put(API_ROLES_URL, role, { headers: httpHeaders })
	}

	// DELETE => delete the role from the server
	deleteRole(roleId: number): Observable<Role> {
		const url = `${API_ROLES_URL}/${roleId}`
		return this.http.delete<Role>(url)
	}

	// Check Role Before deletion
	isRoleAssignedToUsers(roleId: number): Observable<boolean> {
		return this.http.get<boolean>(API_ROLES_URL + '/checkIsRollAssignedToUser?roleId=' + roleId)
	}

	findRoles(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		// This code imitates server calls
		const httpHeaders = new HttpHeaders()
		httpHeaders.set('Content-Type', 'application/json')
		return this.http.post<QueryResultsModel>(API_ROLES_URL + '/findRoles', queryParams, { headers: httpHeaders })
	}

	loginByToken()
	{
		let rpcMethod = new JSONRpc({
			jsonrpc: "2.0",
			method: "webservice.connection:connectbytoken",
		})
		return this.http.post<any>(environment.webservice, rpcMethod).pipe(
			map((data) => {
				let _user = new User()
				if (data.result && data.result.connect == "OK") {
					this.setUser(_user, data);
					return _user
				}
				else
					return false

			})
		)
	}

	/*
	 * Handle Http operation that failed.
	 * Let the app continue.
   *
   * @param operation - name of the operation that failed
	 * @param result - optional value to return as the observable result
	 */
	private handleError<T>(operation = 'operation', result?: any) {
		return (error: any): Observable<any> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error) // log to console instead

			// Let the app keep running by returning an empty result.
			return of(result)
		}
	}

	private setUser(_user: User, data)
	{
		_user.id = data.result.user.ID
		_user.username = data.result.user.login
		_user.email = data.result.user.email
		_user.accessToken = data.result.token
		_user.pic = data.result.user.avatar.data
		_user.fullname = data.result.user.firstname + " " + data.result.user.name
		_user.nom = data.result.user.name
		_user.prenom = data.result.user.firstname
		_user.sexe = data.result.user.sexe
		_user.lists = data.result.lists
		_user.droits = data.result.droits ? data.result.droits : ''
		_user.droitsObjets = data.result.droitsObjets ? data.result.droitsObjets : ''
		_user.signature = data.result.signature ? data.result.signature : ''
		_user.signature_text = data.result.signature_text ? data.result.signature_text : ''
		_user.signature_url = data.result.signature_url ? data.result.signature_url : ''
		_user.signature_etat = data.result.signature_etat ? data.result.signature_etat : ''
		_user.vidalAPI = data.result.vidalAPI
		_user.type=data.result.type
		environment.tokenauth = data.result.token
		environment.production = data.result.environnement === "prod" ? true : false
	}
}
